import React, { useState } from 'react';

import ReportDataProblemModal from './ReportDataProblemModal';
import styles from './styles';

import { Button } from '@cobliteam/ui/components';

// @ts-ignore
import { ReactComponent as CampaignIcon } from './resources/speaker_icon.svg';

const ReportDataProblemModalButton = () => {
  const [showReportDataProblemModal, setShowDataProblemModal] =
    useState<boolean>(false);

  return (
    <>
      <Button
        variant='text'
        type='button'
        onClick={() => setShowDataProblemModal(true)}
        className={styles.reportDataProblemButton}
      >
        <CampaignIcon /> Enviar opinião
      </Button>

      {showReportDataProblemModal && (
        <ReportDataProblemModal
          onClose={() => setShowDataProblemModal(false)}
        />
      )}
    </>
  );
};

export default ReportDataProblemModalButton;
